import React, { useEffect, useState } from 'react';
import { ExpandableRow } from './ExpandableRow';
import { formatCell, generateRowKey, getSortTypeForColumn, sortRows, } from './utils';
import { TableHead, Cell, HeaderCell, HeaderCellButton, Row, Wrap, TableWrapper, BorderContainer, } from './styled';
import { Footer } from './Footer/Footer';
export function Table(props) {
    var _a;
    const { data, footerData, columns, expandable, expanded, sortColumn, sortDirection: defaultSortDirection, customSortFunction, handleSortChange, } = props;
    const [sortKey, setSortKey] = useState(sortColumn !== null && sortColumn !== void 0 ? sortColumn : '');
    const [sortType, setSortType] = useState((_a = getSortTypeForColumn(sortKey, columns)) !== null && _a !== void 0 ? _a : '');
    const [sortDirection, setSortDirection] = useState(defaultSortDirection !== null && defaultSortDirection !== void 0 ? defaultSortDirection : '');
    useEffect(() => {
        setSortKey(sortColumn !== null && sortColumn !== void 0 ? sortColumn : '');
        setSortDirection(defaultSortDirection !== null && defaultSortDirection !== void 0 ? defaultSortDirection : '');
    }, [sortColumn, defaultSortDirection]);
    function handleSortClicked(nextSortKey) {
        var _a;
        const nextSortDirection = sortKey === nextSortKey && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(nextSortDirection);
        setSortKey(nextSortKey);
        setSortType((_a = getSortTypeForColumn(nextSortKey, columns)) !== null && _a !== void 0 ? _a : sortType);
        handleSortChange === null || handleSortChange === void 0 ? void 0 : handleSortChange(nextSortKey, nextSortDirection);
    }
    function getSortedData() {
        if (!sortKey || !sortDirection) {
            return data;
        }
        const clone = [...data];
        const columnToSort = columns.filter((c) => c.key === sortKey)[0];
        const sortFunction = customSortFunction !== null && customSortFunction !== void 0 ? customSortFunction : sortRows;
        return sortFunction(clone, columnToSort, sortDirection, sortType);
    }
    function renderHeaderColumns() {
        const { sortable } = props;
        if (sortable) {
            return (React.createElement("tr", null, columns.map(({ key, name, style }) => (React.createElement(HeaderCell, { key: `header-${name}`, style: style },
                React.createElement(BorderContainer, null,
                    React.createElement(HeaderCellButton, { onClick: sortable
                            ? () => {
                                handleSortClicked(key);
                            }
                            : null }, `${name}${key === sortKey
                        ? ` ${sortDirection === 'asc' ? ' ▲' : ' ▼'}`
                        : ''}`)))))));
        }
        return (React.createElement("tr", null, columns.map(({ name, style }) => (React.createElement(HeaderCell, { key: `header-${name}`, style: style },
            React.createElement(BorderContainer, null, name))))));
    }
    function renderBody() {
        const sortedData = getSortedData();
        if (expandable) {
            return (React.createElement("tbody", null, sortedData.map((row) => {
                var _a;
                const rowKey = generateRowKey(row, columns);
                const hasSubRows = ((_a = row.subRows) === null || _a === void 0 ? void 0 : _a.length) > 0;
                if (!hasSubRows) {
                    return React.createElement(Row, { key: rowKey }, renderCells(row));
                }
                return (React.createElement(ExpandableRow, { expanded: expanded, key: rowKey, columns: columns, row: row }));
            })));
        }
        return (React.createElement("tbody", null, sortedData.map((row) => {
            const rowKey = generateRowKey(row, columns);
            return React.createElement(Row, { key: rowKey }, renderCells(row));
        })));
    }
    function renderCells(row) {
        return columns.map((column) => {
            const rowKey = generateRowKey(row, columns);
            const cellKey = `cell-${column.key}-${rowKey}`;
            const styles = Object.assign(Object.assign({}, column.style), row.style);
            return (React.createElement(Cell, { key: cellKey, style: styles }, formatCell(row, column)));
        });
    }
    return (React.createElement(TableWrapper, Object.assign({}, props),
        React.createElement(Wrap, { columns: columns.length, cellPadding: 0, cellSpacing: 0 },
            React.createElement(TableHead, null, renderHeaderColumns()),
            renderBody(),
            React.createElement(Footer, { footerData: footerData, columns: columns }))));
}
export default Table;
